module.exports = __webpack_public_path__ + "static/media/plus.f247d9f9.svg";